/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import { apiFetch } from '../../../apiClient';
 import { getSessionDatas } from '../../../utils';
 import { apiMap, settings } from '../../../config/constants';
export const ON_HANDLE_AGREEMENT = 'ON_HANDLE_AGREEMENT';

export const onHandleAgreement = (data) => ({
    type: ON_HANDLE_AGREEMENT,
    data
});
/* istanbul ignore next */
export const sumbitApplication = () => dispatch => {
    const { applicationId } = getSessionDatas();
    const sumbitApplicationParams = {
        hostname: settings.hostnameSubmit,
        paramsObj: {
            applicationId
        },
        method: settings.post,
    };
    return apiFetch(apiMap.submitApp, sumbitApplicationParams)(dispatch);
 }



// WEBPACK FOOTER //
// ./src/views/Agreement/state/action.js